/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewings_Create_TitleInputs */

const cs_viewings_create_title = /** @type {(inputs: Viewings_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nová prohlídka`)
};

const en_viewings_create_title = /** @type {(inputs: Viewings_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New viewing`)
};

/**
* | output |
* | --- |
* | "New viewing" |
*
* @param {Viewings_Create_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const viewings_create_title = /** @type {((inputs?: Viewings_Create_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewings_Create_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewings_create_title(inputs)
	return cs_viewings_create_title(inputs)
});